"use client"; // Error boundaries must be Client Components

import Button from "@/components/Button";
import { isServer } from "@/utils/helpers";
import classNames from "classnames";
import { useEffect } from "react";
import Div100vh from "react-div-100vh";
import { useTranslation } from "react-i18next";
import * as Sentry from "@sentry/nextjs";

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const { t } = useTranslation();

  useEffect(() => {
    // Log the error to Sentry
    Sentry.captureException(error);
  }, [error]);

  return (
    <Div100vh className="flex flex-col justify-center items-center text-center">
      <h1 className={classNames("text-mobile-h2 mb-4")}>
        {t("Leider ist etwas schief gelaufen")}
      </h1>
      <p className={classNames("text-mobile-p2 mb-4")}>
        {t("Es ist ein Fehler aufgetreten, bitte laden Sie die Seite neu.")}
      </p>
      <Button
        onClick={() => {
          if (!isServer()) {
            // Use window.location.origin and pathname to keep only the base URL
            const { origin, pathname } = window.location;
            window.location.href = `${origin}${pathname}`;
          }
        }}
      >
        {t("Neu laden")}
      </Button>
    </Div100vh>
  );
}
